export default {
    UPDATED: 'PURCHASE_ADDRESS.UPDATE'
};
